<template>
  <div class="list" ref="list" :key="key">

    <div :class="['item', item.loading ? 'loading' : '']" v-for="item, key in items" :key="item.key" @click="startEdit(item); click(key)">
      
      <slot v-if="editingId === item.id"  name="itemEdit" v-bind:item="item">
        <textarea
          v-model="item.value" 
          ref="textarea"
          @blur="onEdit(item)"
          :disabled="item.loading"
          :style="textareaStyling"
          rows="1"/>
      </slot>

      <div v-else>
        <slot class="display" name="itemDisplay" v-bind:item="item">
          {{ item.value }}
        </slot>
      </div>

      <div class="options" v-if="key === showingOptions">
          <span class="delete" @click="delete_(item)">delete</span>
      </div>

    </div>

    <div v-if="loading" class="fetching"><div class="lds-ripple"><div></div><div></div></div></div>
  </div>
</template>

<script>
export default {
    name: 'Panel',
    props: {
      items: {
        type: Array,
        validator: (items) =>
          items.every(item => item.id && item.value && item.loading != null)
      },
      editable: {
        type: Boolean,
        default: true
      },
      loading: {
        type: Boolean
      }
    },
    data() {
      return {
        key: 0,
        editingId: undefined,
        editingText: '',
        showingOptions: undefined,
        textareaStyling: ''
      }
    },
    methods: {
      onEdit(item) {
        this.editingId = undefined;
        
        if (item.value === this.editingText || item.value === '') return;

        this.editingText = '';

        this.$emit('edit', item);
      },
      stopEdit() {
        this.editingId = undefined;
        this.editingText = '';
      },
      startEdit(item) {
        if (!this.editable) return;

        this.editingId = item.id;
        this.editingText = item.value;

        setTimeout(() => {
          if (this.$refs.textarea)
            this.$refs.textarea[0].focus();
        }, 10);
      },
      click(index) {
        if (!this.editable) return;

        this.showOptions(index);
      },
      showOptions(index) {
        this.showingOptions = index;
      },
      delete_(item) {
        this.$emit('delete', item);
      }
    },
    watch: {
      editingId: function() {
        this.$nextTick(() => {
          if (this.$refs.textarea && this.$refs.textarea[0])
            this.textareaStyling = `height: ${this.$refs.textarea[0].scrollHeight - 4}px`;
          else 
            this.textareaStyling = '';
        })
      }
    },
    mounted() {
      this.$refs.list.addEventListener('scroll', (e) => {
        if (e.target.scrollTop === (e.target.scrollHeight - e.target.offsetHeight))
          this.$emit('reached-bottom')
      })
    }
}
</script>

<style scoped>

.list {
  height: 100%;
  overflow-y: scroll;
}

input {
  background-color: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  padding: 0;
  margin: 0;
}

.item {
  background-color: #5390d9;
  border-radius: 10px;
  padding: 2px;
  margin: 2px 0;
  transition: 200ms;
  display: flex;
  justify-content: space-between;
  animation: fadeIn 200ms 1;

  position: relative;
}

.loading {
  animation: loading 1s infinite;
}

.options {
  background-color: rgb(209, 77, 77);
  border-radius: 10px;
  width: 50px;
  position: absolute;
  right: 3px;
  top: 3px;
  bottom: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: 20px;
}

.delete {
  font-size: 12px;
  transition: 200ms;
  z-index: 10;
}

.delte:active {
  background-color: rgb(155, 61, 61);
  transition: 200ms;
}

@keyframes loading {
  0% {
    opacity: 1;
  }
  50% {
    opacity: .7;
  }
  100% {
    opacity: 1;
  }
}

.fetching {
  width: 100%; 
  display: flex;
  justify-content: center;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.display {
  user-select: all;
}

</style>


// WEBPACK FOOTER //
// src/components/List.vue